const actions = {
  SET_STATE: 'data/SET_STATE',
  UPDATE_RESERVATION: 'reservation/UPDATE',
  getAvailableRooms: 'reservation/getAvailableRooms',
  getInitialState: 'data/INITIAL_STATE',
  getLoadBE :'data/WAIT_BE_PROMISE'
}

export default actions
